import { takeLatest, put, call } from "redux-saga/effects"
import { FETCH_MEMBERS } from "../constants"
import { fetchMembersSuccess, fetchMembersFail } from "../actions"
import { Post } from "../lib/Request"

function* getMembers() {
  try {
    const {
      message: { result },
    } = yield call(Post, "/members", {
      args: {
        type: "getAll",
      },
    })
    yield put(fetchMembersSuccess(result))
  } catch (error) {
    yield put(fetchMembersFail(error.message))
  }
}

export default function* membersSaga() {
  yield takeLatest(FETCH_MEMBERS.REQUEST, getMembers)
}
